import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';

const HierarchyContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 11px;
  color: ${COLORS.GRAY};
  margin-top: 2px;
`;

const HierarchyItem = styled.span`
  white-space: nowrap;
`;

const HierarchySeparator = styled.span`
  margin: 0 4px;
  color: #999;
`;

const TechnologyHierarchyPath = ({ hierarchy, hideFirstLevel = false, hideLastLevel = false }) => {
  if (!hierarchy || hierarchy.length === 0) {
    return null;
  }

  let displayHierarchy = hierarchy;
  if (hideFirstLevel) {
    displayHierarchy = displayHierarchy.slice(1);
  }
  if (hideLastLevel) {
    displayHierarchy = displayHierarchy.slice(0, -1);
  }

  if (displayHierarchy.length === 0) {
    return null;
  }

  return (
    <HierarchyContainer>
      {displayHierarchy.map((item, index) => (
        <React.Fragment key={item.id}>
          <HierarchyItem>{item.name}</HierarchyItem>
          {index < displayHierarchy.length - 1 && (
            <HierarchySeparator>&gt;</HierarchySeparator>
          )}
        </React.Fragment>
      ))}
    </HierarchyContainer>
  );
};

TechnologyHierarchyPath.propTypes = {
  hierarchy: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  hideFirstLevel: PropTypes.bool,
  hideLastLevel: PropTypes.bool,
};

TechnologyHierarchyPath.defaultProps = {
  hierarchy: [],
  hideFirstLevel: false,
  hideLastLevel: false,
};

export default TechnologyHierarchyPath;
